import {useTranslation} from '@aboutyou/i18n';
import {useCanGoBack, useHistory} from '@aboutyou/router';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  Text,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

export const GiftCardRefundFormHeader = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const canGoBack = useCanGoBack();

  const handleBackClick = () => {
    if (canGoBack) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  return (
    <Wrapper>
      <IconWrapper onClick={handleBackClick}>
        <BackIcon asset={GenericIconName.ArrowLeft} />
        <BackText color="Grey1" size="px14">
          {t('Back')}
        </BackText>
      </IconWrapper>
      <HeaderText>{t('Gift card refund')}</HeaderText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${COLORS.White};
  padding: 0.8125rem 0rem;
  border-bottom: 1px solid ${COLORS.Grey3};
  display: flex;
  align-items: center;
  ${tabletAndUp(css`
    background-color: inherit;
    border: none;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.375rem;
  `)}
`;

const HeaderText = styled(Text)`
  font-size: ${FONT_SIZES.px20};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  text-align: center;
  flex: 1;
  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px32};
    font-weight: ${FONT_WEIGHTS.heavy};
  `)}
  line-height: 24px;
`;

const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${tabletAndUp(css`
    color: ${COLORS.Grey1};
  `)}
`;

const BackIcon = styled(Icon)`
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 0.75rem;

  ${tabletAndUp(css`
    fill: ${COLORS.Grey1};
  `)}
`;

const BackText = styled(Text)`
  display: none;
  ${tabletAndUp(css`
    display: inline;
  `)}
`;
